export const ASSETS = {
  app_details: 'app_details',
};

export const SUB_ASSETS = {
  [ASSETS.app_details]: ['about_data', 'app_about', 'installed_sdks', 'x_ray_tags'],
};
